import { reactive, computed } from 'vue'
import { Router } from 'vue-router'
import { QuestionsStore } from '@/stores/common/questions'
import { ComputableObject } from '@/types/global'
import { IQuestionsResultState } from '@/types/common/questions'

import { routerConstants } from '@/constants/routers/common'
const { PATH } = routerConstants.LOCATION

export const useStates = (store: QuestionsStore): IQuestionsResultState => {
  return reactive<ComputableObject<IQuestionsResultState>>({
    isLoading: true,
    isShares: computed(() => store.state.result.isRecommend && store.state.result.photographers.length > 0),
  })
}

export const useActions = (store: QuestionsStore, router: Router) => {
  /**
   * もう一度診断する
   */
  const restart = (): void => {
    store.clearInputs()
    router.push({ path: PATH.QUESTIONS_ONE })
  }

  return {
    restart: restart,
  }
}
